import { CardMedia, Skeleton } from "@mui/material";
import type { FC } from "react";
import { useEffect, useState } from "react";
import { storageUrlWithCredentials } from "../components/imagesPreview/storageUrlWithCredentials";
import type { ImageFlavour } from "./publicPackagesApi";

export interface ImageDTO {
  readonly id: string;
  readonly name: string;
  readonly thumbnail: {
    readonly url: string;
  };
  readonly original: {
    readonly url: string;
  };
  readonly www: {
    readonly url: string;
  };
  readonly flavours: Partial<Record<ImageFlavour, { readonly url: string }>>;
}

interface Props {
  readonly image: ImageDTO | undefined;
  readonly margin?: number;
}

const CardImage: FC<Props> = ({ image, margin }) => {
  const [thumbnailUrl, setThumbnailUrl] = useState<string>();
  const imageSize = 300 - (margin ? 2 * margin : 0);

  useEffect(() => {
    if (image?.thumbnail.url) {
      storageUrlWithCredentials(image.thumbnail.url).then((url) => setThumbnailUrl(url));
    } else {
      setThumbnailUrl(undefined);
    }
  }, [image?.thumbnail.url]);

  if (!image) {
    return (
      <CardMedia
        component="img"
        sx={{ width: imageSize, height: imageSize, margin: `${margin}px` }}
        alt="Brak zdjęcia"
      />
    );
  }

  if (!thumbnailUrl) {
    return (
      <Skeleton
        animation="wave"
        variant="rectangular"
        width={imageSize}
        height={imageSize}
        sx={{ margin: `${margin}px` }}
      />
    );
  }

  return (
    <CardMedia
      component="img"
      sx={{ width: imageSize, height: imageSize, margin: `${margin}px` }}
      image={thumbnailUrl}
      loading="lazy"
      alt={image.name}
    />
  );
};

export default CardImage;
